/** @format */

/**
 * The service levels (shipping methods), in order, to search for when grabbing a SKU's estimated delivery date (EDD) from the API.
 *
 * LTL products have a hierarchy of service levels that should be used to determine the EDD.
 * This hierarchy was defined and provided to us by stakeholders.
 *
 * No products should be both P_ and LTL_, so P_Ground is #1 in the hierarchy, since that's more common.
 */
export const EDD_SERVICE_LEVEL_HIERARCHY = [
	'P_Ground',
	'LTL_Curbside',
	'LTL_Threshold',
	'LTL_ROC',
	'LTL_Assembly'
] as const;
